/**
 * VapouRevolution Core Engine & Interactive Functions
 */
window.VapouRevolution = window.VapouRevolution || {};

// 1. Shopify 加购 Ajax API 对接
window.VapouRevolution.addToCart = async function(variantId, quantity = 1) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }]
      })
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const item = await response.json();
    console.log('[Shopify Cart API] 商品成功加购:', item);
    
    // 触发全局购物车刷新事件
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: item }));
    alert('✅ 已成功加入购物车！');
    return item;
  } catch (error) {
    console.error('[Shopify Cart API Error] 加购失败:', error);
    alert('❌ 加购失败，请重试。');
  }
};

// 2. 邮编 Delivery Checker 校验逻辑
window.VapouRevolution.checkDelivery = function() {
  const input = document.getElementById('delivery-postal-input');
  const resultDiv = document.getElementById('delivery-result-msg');
  if (!input || !resultDiv) return;
  
  const value = input.value.trim().toUpperCase();
  if (!value) {
    resultDiv.style.display = 'block';
    resultDiv.style.color = '#EF4444';
    resultDiv.innerText = '请输入有效的加拿大邮编 (例如: T2P 1J9)';
    return;
  }
  
  // 简易卡尔加里 / 加拿大邮编识别逻辑
  resultDiv.style.display = 'block';
  resultDiv.style.color = '#10B981';
  resultDiv.innerText = `🎉 恭喜！邮编 [${value}] 包含在卡尔加里当日送达范围内 (Same Day Delivery Available)`;
};

// 3. 心愿单 (Wishlist) 交互
window.VapouRevolution.toggleWishlist = function(productId, buttonElement) {
  let wishlist = JSON.parse(localStorage.getItem('vapour_wishlist') || '[]');
  const index = wishlist.indexOf(productId);
  
  if (index > -1) {
    wishlist.splice(index, 1);
    buttonElement.style.color = 'currentColor';
    console.log(`[Wishlist] 商品 ${productId} 已移除`);
  } else {
    wishlist.push(productId);
    buttonElement.style.color = '#EF4444';
    console.log(`[Wishlist] 商品 ${productId} 已收藏`);
  }
  
  localStorage.setItem('vapour_wishlist', JSON.stringify(wishlist));
};

document.addEventListener('DOMContentLoaded', () => {
  console.log('VapouRevolution Screen.png Theme System Ready.');
});
